module.exports = __webpack_public_path__ + "img/2.a15c7283.png";